import { PractitionerScheduleLocation } from '~/storm'

import { DatePractitionerCell } from '../../../shared'
import { ModalElement } from '../ModalElement'
import { LocationTagsWithStaticState } from './LocationTagsWithStaticState'
import { useLocationsForPractitionerScheduleModal } from './useLocationsForPractitionerScheduleModal'

type LocationGroup = ReturnType<typeof useLocationsForPractitionerScheduleModal>['locationGroups']['selectedSpecialties']

type LocationGroupElementsProps = {
    group: LocationGroup
    selectedCells: DatePractitionerCell[]
    practitionerScheduleLocations: PractitionerScheduleLocation[]
}

export const LocationGroupElements = ({ group, selectedCells, practitionerScheduleLocations }: LocationGroupElementsProps) => {
    const groupElements = [
        { label: 'Ledige', locations: group.available },
        { label: 'Med kirurg', locations: group.unavailable },
    ]

    return groupElements.map(({ label, locations }) => (
        <ModalElement
            key={label}
            secondaryLabel={{
                label,
                count: locations.length,
                maxCount: group.maxCount,
            }}
            hasItems={locations.length > 0}
        >
            <LocationTagsWithStaticState selectedCells={selectedCells} locations={locations} practitionerScheduleLocations={practitionerScheduleLocations} />
        </ModalElement>
    ))
}
